import {LTServices} from "../lt-services";
import {ILtToolbarOptions} from "../../utility/toolbar";
import {FeaturesEvents} from "../../services/events/FeaturesEvents";
import {_F} from "../../utility/func";
import Feature from "ol/Feature";
import VectorSource from "ol/source/Vector";
import Point from "ol/geom/Point";
import {Draw, Modify} from "ol/interaction";
import {primaryAction, shiftKeyOnly, singleClick, noModifierKeys} from "ol/events/condition";
import IMapService = LTServices.IMapService;
import pinTitleFromFeature = _F.pinTitleFromFeature;
import {MapBrowserEvent} from "ol";
import ContextMenu from "ol-contextmenu";
import {GeoAppEvents} from "../../controllers/events/geoapp_events";
import {DrawEvent} from "ol/interaction/Draw";
import {Geometry} from "ol/geom";

export function createPortalContextMenu($scope: ng.IScope, mapService : IMapService) : any {
	const contextMenu = new ContextMenu({
		width: 170,
		defaultItems: true
	});

	$scope.$on('toggleContextMenu', (event, onOrOff : boolean)=> {
		let map = mapService.map;

		if (onOrOff) {
			if (map.getControls().getArray().indexOf(contextMenu) === -1) {
				map.addControl(contextMenu);
			}
		} else {
			map.removeControl(contextMenu);
		}
	});



	interface IRemovePin {
		text: string;
		feature: Feature<Geometry>;
		source: VectorSource<Geometry>;
		callback();
	}

	const removePin : IRemovePin = {
		text: 'Remove Pin',
		feature: null,
		source: null,
		callback: () => {
			if (removePin.feature) {
                removePin.source.removeFeature(removePin.feature);
                $scope.$root.$broadcast(FeaturesEvents.featureRemoved, removePin.feature, true);
			}
		}
	};

    const removeUnsavedPins: IRemovePin = {
        text: 'Remove all unsaved pins from the map',
        feature: null,
        source: null,
        callback: () => $scope.$root.$broadcast(GeoAppEvents.removeUnsavedPins)
    };

	const deletePin: IRemovePin = {
		text: `Delete pin from My Features and remove from map`,
		feature: null,
		source: null,
		callback: () => {
			const f = deletePin.feature;
			if (f && confirm(`Delete "${pinTitleFromFeature(f) || 'saved pin'}" from my features?`)) {
				deletePin.source.removeFeature(f);
				$scope.$root.$broadcast(FeaturesEvents.featureRemoved, f, true);
			}
		}
	};

	let restore = false;
	let contextOpened = false;
	let contextClosing = false;

    document.querySelector('body').addEventListener('click', function () {
        if (contextMenu.isOpen()) {
            contextMenu.close();
        }
    });

	contextMenu.on('open', (ev) => {
		console.log("Context menu open");
		let map = mapService.map;
		contextOpened = true;


		let layer = null;
		let feature = <Feature<Geometry>> map.forEachFeatureAtPixel(
			ev.pixel,
			(ft, l) => {
				layer = l;
				return ft ;
			});

		if (feature) {
			if (feature.getGeometry() instanceof Point) {
				contextMenu.clear();
				if (layer === mapService.featuresLayer) {
					if (feature.get('saved')) {
						deletePin.feature = feature;
						deletePin.source = mapService.featuresLayer.getSource();
						contextMenu.push(deletePin);
					} else {
						removePin.feature = feature;
						removePin.source = mapService.featuresLayer.getSource();
						contextMenu.push(removePin);
                        contextMenu.push(removeUnsavedPins);
					}
				} else {
					contextMenu.extend(contextMenu.getDefaultItems());
					restore = false;
					return;
				}
			} else if (layer == mapService.featuresLayer) {
				contextMenu.clear();
				let doRemove = () => {
                    layer.getSource().removeFeature(feature);
                    $scope.$root.$broadcast(FeaturesEvents.featureRemoved, feature, true);
                };
				contextMenu.extend([{
					text: 'Remove',
					callback: () => {
						if ($scope.$$phase) {
							doRemove();
						} else {
							$scope.$apply(doRemove);
						}
					}
				}, {
					text: 'Modify',
					callback: () => {
						// Allows the user to modify the area query polygon
						let source = mapService.featuresLayer.getSource();
						// let geom = source.getFeatures()[0].getGeometry();
						// let revision = geom.getRevision();
						// let clone = (<any> geom).clone();

						let anyChanges =  false;

						let mod = new Modify({ // out of date api, cast needed
							source,
							insertVertexCondition: (e) => {
								return primaryAction(e);
							},
							deleteCondition: (e) => singleClick(e) && shiftKeyOnly(e)
						});

						mod.once('modifyend', () => {
							anyChanges = true;
						});

						const draw = new Draw({
                            source,
							condition: (e) => {
								return primaryAction(e) && noModifierKeys(e);
							},
							type: 'Polygon'
						});

                        const interactions = [mod, draw/*, snap*/];

						draw.on('drawend', (ev: DrawEvent) => {
							console.log(ev);
							anyChanges = true;
							if (ev.feature) {
								$scope.$root.$broadcast(FeaturesEvents.featuresAdded, [ev.feature]);
							}
						});

						interactions.forEach((interaction) => mapService.map.addInteraction(interaction));

						const evtOffs: (() => void)[] = [];

						const cleanUp = () => {
							if (mod.getActive()) {
								mod.setActive(false);
								mapService.map.removeInteraction(mod);
							}

							if (draw.getActive()) {
								draw.abortDrawing();
								draw.setActive(false);
								mapService.map.removeInteraction(draw);
							}

							$scope.$root.$broadcast(GeoAppEvents.hideToolbar);

							evtOffs.forEach(f => f());
						}

						const offHideReport = $scope.$on(FeaturesEvents.featuresBackToStart, cleanUp);
						const offReportChanged = $scope.$on(FeaturesEvents.reportChanged, cleanUp);
						evtOffs.push(offHideReport, offReportChanged);

						let toolbarOptions : ILtToolbarOptions = {
							title: 'Modify the area query',
							onClose: () => { },
							/*lhsActions: [{
								title: 'Cancel',
								icon: 'icon icon-cancel',
								showTitle: false,
								onClick: () => {
									if (geom.getRevision() != revision) {
										source.getFeatures()[0].setGeometry(clone);
									}
									$scope.$root.$broadcast('hide-toolbar');
								}
							}],*/
							cssClasses: 'toolbar bg-edit-features cst-mercury',
							showClose: false,
							rhsActions: [
								{
									title: 'Done',
									showTitle: true,
									icon: 'icon icon-ok',
									onClick: () => {
                                        interactions.forEach((interaction) => mapService.map.removeInteraction(interaction));
                                        if (anyChanges) {
                                            let features = source.getFeatures();
											$scope.$root.$broadcast('resetAreaQueryShare');
											$scope.$root.$broadcast('doAreaQuery', features[0].getGeometry());
											$scope.$root.$broadcast(FeaturesEvents.featuresEdited);
										}

										$scope.$root.$broadcast('hide-toolbar');
									}
								}
							]
						};

						let toolbarId = 'modify-features';
						let show = () => $scope.$root.$broadcast(GeoAppEvents.showToolbar, toolbarOptions, toolbarId);
						if ($scope.$$phase) {
							show();
						} else {
							$scope.$apply(show);
						}
					}
				}]);
			}

			restore = true;
		} else if (restore) {
			contextMenu.clear();
			contextMenu.extend(contextMenu.getDefaultItems());
			restore = false;
		}
	});

	contextMenu.on('close', () => {
		contextClosing = true;
		setTimeout(() => {
			contextOpened = false;
			contextClosing = false;
			console.log("Context menu closed")
		}, 500);
	});

	mapService.mapPromise.then((map) => {
		map.on('singleclick', (mapBrowserEvent : MapBrowserEvent<MouseEvent>) => {
			if (contextOpened || contextClosing) {
				// if the context menu is open, and someone left-clicks the map, the
				// menu should just be closed, we don't want to fire the default click handler.
				mapBrowserEvent.stopPropagation();
			}
		});
	});

	return contextMenu;
}
